import { ToItemTypeMetadata } from "../item-type-metadata.enum"
import { ItemMetadata } from "../item/item-metadata.model"
import { MetadataFactory } from "../metadata.factory"
import { ObjectJsonSchema } from "../schema/object-json-schema.model"
import { LayoutMetadata, LayoutMetadataBase } from "./layout-metadata.model"


export class RowLayoutMetadataBase extends LayoutMetadataBase {


    items: ItemMetadata [] = []
    
    constructor(type: string) {
        super(type)
    }

    from(layout: LayoutMetadata): void {
        Object.assign(this, layout)
        for (let i = 0; i < this.items.length; i++) {
            const element = this.items[i]
            let type = ToItemTypeMetadata(element.type)
            if (type == null) continue

            let item = MetadataFactory.createItem(type)
            item.from(element)
            this.items[i] = item
        }
    }

    schema(schema: ObjectJsonSchema) {
        this.items.forEach(widget => {
            if (widget.required) schema.required.push(widget.fieldName)
            schema.properties[widget.fieldName] = widget.schema()
        })
    }

}

export interface RowLayoutMetadata extends RowLayoutMetadataBase { }